import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SkModalBase } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-field-department-modal',
  styleUrls: ['./field-department-modal.component.scss'],
  templateUrl: './field-department-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IrisFieldDepartmentModalComponent extends SkModalBase<IrisFieldDepartmentModalComponent, string[]> implements OnInit {
  readonly data = inject<{
    departments: IrisDepartmentI[];
    dSources: IrisDepartmentI[][];
    options: Record<string, never>;
    selection: string[];
  }>(MAT_DIALOG_DATA);

  readonly departments = this.data.departments ?? [];
  readonly dSources = this.data.dSources ?? [];
  readonly options = this.data.options ?? {};
  readonly selection: string[] = this.data.selection ?? [];
  isInited = [];

  private static pushOrSet(collection: unknown[], index: number, val: unknown): void {
    if (collection.length > index) {
      collection[index] = val;
    } else {
      collection.push(val);
    }
  }

  ngOnInit(): void {
    this.isInited = [];
  }

  setEmpty(_event: unknown): void {
    this.closeWithResult(null);
  }

  accept(): void {
    this.closeWithResult(this.selection);
  }

  processSelection(value: unknown, nodeIndex: number): void {
    IrisFieldDepartmentModalComponent.pushOrSet(this.selection, nodeIndex, value);
    if (!this.isInited[nodeIndex]) {
      this.isInited[nodeIndex] = true;
      return;
    }
    if (this.options.downLevel && (this.options.downLevel <= nodeIndex + 1)) { return; }
    if (value) {
      const newSource = this.departments.filter(d => d.parentId == this.selection[nodeIndex]);
      if (newSource.length || this.options.downLevel) {
        IrisFieldDepartmentModalComponent.pushOrSet(this.dSources, nodeIndex + 1, this.departments.filter(d => d.parentId == this.selection[nodeIndex]));
        IrisFieldDepartmentModalComponent.pushOrSet(this.selection, nodeIndex + 1, null);
      } else {
        this.selection.splice(nodeIndex + 1, Number.MAX_VALUE);
        this.dSources.splice(nodeIndex + 1, Number.MAX_VALUE);
      }
    } else {
      this.selection.splice(nodeIndex + 1, Number.MAX_VALUE);
      this.dSources.splice(nodeIndex + 1, Number.MAX_VALUE);
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}
